import { ActionIcon, Button, Divider, Menu, Text, useMantineTheme } from '@mantine/core';
import { IconChevronDown, IconFilePlus } from '@tabler/icons-react';
import { useState } from 'react';

interface Props {
  onClickFastDraft: () => void
  onClickFullSetup: () => void
  isLoading?: boolean
  useIconForTarget?: boolean
}

const NewProposalMenu: React.FC<Props> = (props: Props) => {
  const { onClickFastDraft, onClickFullSetup, isLoading = false, useIconForTarget = false } = props;
  const { other: colorVars } = useMantineTheme();
  const [createProposalMenuOpened, setCreateProposalMenuOpened] = useState(false);

  const iconTarget = (
    <ActionIcon disabled={isLoading}
      variant='subtle'
      onClick={(e) => { setCreateProposalMenuOpened((o) => !o); e.stopPropagation(); }}>
      <IconFilePlus color={colorVars.primaryIconColor} />
    </ActionIcon>
  );
  const buttonTarget = (
    <Button
      disabled={isLoading}
      onClick={() => { setCreateProposalMenuOpened((o) => !o); }}
      pl={16}
      leftSection={<IconFilePlus />}
      rightSection={<IconChevronDown />}
    >
      New Proposal
    </Button>
  );

  return (
    <Menu
      opened={createProposalMenuOpened}
      onChange={setCreateProposalMenuOpened}
      position='bottom-end'
    >
      <Menu.Target >
        {useIconForTarget ? iconTarget : buttonTarget}
      </Menu.Target>
      <Menu.Dropdown w={320}>
        <Menu.Item onClick={onClickFastDraft} p='12px 24px'>
          Fast Draft
          <Text fz='sm' c={colorVars.secondaryTextColor}>
            Skip setup and go straight to generating a full draft of your proposal
          </Text>
        </Menu.Item>
        <Divider />
        <Menu.Item
          onClick={onClickFullSetup}
          p='12px 24px'
        >
          Full Setup
          <Text fz='sm' c={colorVars.secondaryTextColor}>
            Review requirements, structure your outline, and generate content
          </Text>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default NewProposalMenu;
